export default function resolveUserStatus(status) {
  if (status === 'ACTIVE') return { variant: 'success', text: 'Aktywny' }
  if (status === 'INVITED') return { variant: 'warning', text: 'Zaproszony' }
  if (status === 'INACTIVE') return { variant: 'danger', text: 'Nieaktywny' }
  return { variant: 'light', text: 'Nieznany' }
}
